import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetSaltoSpaceConnectionRequest = {
  buildingId: number
}

export type SaltoSpaceZoneRef = { ExtZoneID: string; name: string }
export type SaltoSpaceLevelRef = { ExtGroupID: string; name: string }

export type SaltoSpaceConnection = {
  apiKey?: string
  url?: string
  config?: {
    shouldAutoAssignApartmentDoor?: boolean
    shouldAutoAssignUserAccessLevel?: boolean
    permissionGroups?: SaltoSpaceZoneRef[]
    accessLevels?: SaltoSpaceLevelRef[]
    visitorPermissionGroups?: SaltoSpaceZoneRef[]
    visitorAccessLevels?: SaltoSpaceLevelRef[]
  }
}

export const getSaltoSpaceConnectionQueryKey = (data: GetSaltoSpaceConnectionRequest) => [
  'useGetSaltoSpaceConnection',
  data,
]

const getSaltoSpaceConnection = async (data: GetSaltoSpaceConnectionRequest) => {
  const response = await authAPI.get<SaltoSpaceConnection>(
    `/salto-space/integration/${data.buildingId}`,
  )
  return response.data
}

export const useGetSaltoSpaceConnection = (data: GetSaltoSpaceConnectionRequest) =>
  useQuery({
    enabled: Boolean(data.buildingId),
    queryFn: () => getSaltoSpaceConnection(data),
    queryKey: getSaltoSpaceConnectionQueryKey(data),
  })
